import React from "react";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import bodyImg1 from "../../images/home_body1.jpg";
import bodyImg2 from "../../images/home_body2.jpg";
import "./Home.css";

const ServiceIcons = {
  personal: (
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20Z" stroke="#F44336" strokeWidth="2.5"/><path d="M24 34v-2.5M24 29.5c-2.5 0-4-1.5-4-4 0-2.5 1.5-4 4-4s4 1.5 4 4c0 2.5-1.5 4-4 4Z" stroke="#F44336" strokeWidth="2.5" strokeLinecap="round"/><path d="M24 14v2.5" stroke="#F44336" strokeWidth="2.5" strokeLinecap="round"/></g></svg>
  ),
  investment: (
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><rect x="8" y="12" width="32" height="24" rx="4" stroke="#00BFAE" strokeWidth="2.5"/><path d="M16 20h16M16 24h8" stroke="#00BFAE" strokeWidth="2.5" strokeLinecap="round"/></g></svg>
  ),
  business: (
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><circle cx="24" cy="24" r="20" stroke="#FFC107" strokeWidth="2.5"/><path d="M24 14v10l7 7" stroke="#FFC107" strokeWidth="2.5" strokeLinecap="round"/></g></svg>
  )
};

const Home = () => (
  <div className="home-root">
    <PageBanner title="Welcome to Pawansut Holdings Limited" />
    <div className="section-divider"></div>
    <ScrollReveal variant="fadeUp">
    <section className="intro-section unique-grid-bg">
      <div className="intro-content">
        <h2 className="unique-text-shadow" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>Welcome to Pawansut Holdings Limited</h2>
        <p>
          Pawansut Holdings Limited is a leading NBFC dedicated to providing innovative and accessible financial solutions. Our mission is to empower individuals and businesses with the resources they need to achieve their financial goals, through trust, transparency, and customer-centric service.
        </p>
      </div>
    </section>
    </ScrollReveal>
    {/* <section className="intro-image-section">
      <img src={bodyImg1} alt="Naman Finlease Team" className="intro-image" />
    </section> */}
    <ScrollReveal variant="fadeUp" delay={0.1}>
    <section className="home-features-section">
      <div className="features-container">
        <div className="features-content-wrapper">
          <div className="features-text-content">
            <div className="features-header">
              <h2 className="features-title">Your Financial Journey Starts Here</h2>
              <div className="features-subtitle">Simplified. Secure. Smart.</div>
            </div>
            <p className="features-description">
              Get instant access to personalized financial solutions designed to meet your unique needs. From quick personal loans to smart investment options, we make finance simple and accessible for everyone.
            </p>
            <div className="quick-features">
              <div className="quick-feature-item">
                <div className="quick-feature-icon">🚀</div>
                <span>Quick Applications</span>
              </div>
              <div className="quick-feature-item">
                <div className="quick-feature-icon">💎</div>
                <span>Best Rates</span>
              </div>
              <div className="quick-feature-item">
                <div className="quick-feature-icon">🎯</div>
                <span>Instant Approval</span>
              </div>
            </div>
          </div>
          <div className="features-image-wrapper">
            <div className="image-container">
              <img src={bodyImg1} alt="Financial Solutions" className="features-image" />
              <div className="image-overlay">
                <div className="overlay-text">Smart Finance</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </ScrollReveal>
    <ScrollReveal variant="fadeUp" delay={0.1}>
    <section className="home-info-section">
      <div className="info-container">
        <div className="info-content-wrapper">
          <div className="info-image-wrapper">
            <div className="image-container">
              <img src={bodyImg2} alt="Financial Security" className="info-image" />
              <div className="image-overlay">
                <div className="overlay-text">Secure & Reliable</div>
              </div>
            </div>
          </div>
          <div className="info-text-content">
            <div className="info-header">
              <h2 className="info-title">Trusted Financial Partner</h2>
              <div className="info-subtitle">Your Success is Our Priority</div>
            </div>
            <div className="info-text">
              <p>
                With years of experience in the financial industry, we've helped thousands of customers achieve their financial goals. Our transparent processes and customer-first approach make us the preferred choice for all your financial needs.
              </p>
              <p>
                We are committed to providing secure, reliable, and innovative financial solutions that empower you to build a better financial future. Your trust and satisfaction drive everything we do.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </ScrollReveal>
    <ScrollReveal variant="fadeUp">
    <section className="our-services-section">
      <h2 className="our-services-title">Our Services</h2>
      <div className="our-services-grid">
        <div className="our-service-card card-tilt">
          <div className="service-icon">{ServiceIcons.personal}</div>
          <h3>Personal Loans</h3>
          <p>We offer customized personal loans to meet your specific financial requirements, such as home renovation, education, medical expenses, or debt consolidation.</p>
        </div>
        <div className="our-service-card card-tilt">
          <div className="service-icon">{ServiceIcons.investment}</div>
          <h3>Investment Services</h3>
          <p>We offer a wide range of investment options, including mutual funds, stocks, bonds, and more, to help you grow your wealth and achieve your financial goals.</p>
        </div>
        <div className="our-service-card card-tilt">
          <div className="service-icon">{ServiceIcons.business}</div>
          <h3>Business Loans</h3>
          <p>We provide business loans to small and medium enterprises (SMEs) to help them expand their operations, purchase new equipment, or fund their working capital requirements.</p>
        </div>
      </div>
    </section>
    <section className="why-choose-section">
      <div className="why-choose-container">
        <div className="why-choose-header">
          <h2 className="why-choose-title">Why Choose Pawansut Holdings Limited?</h2>
          <div className="why-choose-subtitle">Your Trusted Financial Partner</div>
        </div>
        <div className="why-choose-grid">
          <div className="why-choose-card">
            <div className="card-icon-wrapper">
              <div className="card-icon">🎯</div>
            </div>
            <div className="card-content">
              <h3>Customer-Centric Approach</h3>
              <p>We prioritize our clients' needs and provide personalized solutions to help them achieve their financial goals.</p>
            </div>
          </div>
          <div className="why-choose-card">
            <div className="card-icon-wrapper">
              <div className="card-icon">👥</div>
            </div>
            <div className="card-content">
              <h3>Experienced Team</h3>
              <p>Our team of financial experts has years of experience in the financial industry and is committed to providing quality financial services to our clients.</p>
            </div>
          </div>
          <div className="why-choose-card">
            <div className="card-icon-wrapper">
              <div className="card-icon">💰</div>
            </div>
            <div className="card-content">
              <h3>Affordable Services</h3>
              <p>We offer affordable financial services to ensure that everyone has access to the financial tools they need to achieve their dreams.</p>
            </div>
          </div>
          <div className="why-choose-card">
            <div className="card-icon-wrapper">
              <div className="card-icon">⚡</div>
            </div>
            <div className="card-content">
              <h3>Easy and Fast Application Process</h3>
              <p>Our online application process is quick and easy, ensuring that you can apply for a loan or investment from the comfort of your home.</p>
            </div>
          </div>
          <div className="why-choose-card">
            <div className="card-icon-wrapper">
              <div className="card-icon">🛡️</div>
            </div>
            <div className="card-content">
              <h3>Secure & Transparent</h3>
              <p>We maintain the highest standards of security and transparency in all our financial operations, ensuring your data and investments are always protected.</p>
            </div>
          </div>
          <div className="why-choose-card">
            <div className="card-icon-wrapper">
              <div className="card-icon">📈</div>
            </div>
            <div className="card-content">
              <h3>Growth-Focused Solutions</h3>
              <p>Our financial products and services are designed to help you grow your wealth and achieve long-term financial stability and success.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </ScrollReveal>
  </div>
);

export default Home; 